import _extends from '@babel/runtime/helpers/extends';
import React, { forwardRef, Children, cloneElement } from 'react';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _jsx from '@babel/runtime/helpers/jsx';
import includes from '@andes/common/build/utils/includes';
import FeedbackPositive16 from '@andes/icons/FeedbackPositive16';
import FeedbackPositive18 from '@andes/icons/FeedbackPositive18';
import FeedbackPositive20 from '@andes/icons/FeedbackPositive20';
import FeedbackPositive24 from '@andes/icons/FeedbackPositive24';
const namespace = 'andes-typography';
const textListNamespace = "".concat(namespace, "-text-list");
const textListItemNamespace = "".concat(textListNamespace, "__item");
const COLOR_PRIMARY = 'primary';
const COLOR_SECONDARY = 'secondary';
const COLOR_DISABLED = 'disabled';
const COLOR_INVERTED = 'inverted';
const COLOR_LINK = 'link';
const COLOR_NEGATIVE = 'negative';
const COLOR_CAUTION = 'caution';
const COLOR_POSITIVE = 'positive';
const AVAILABLE_COLORS = [COLOR_PRIMARY, COLOR_SECONDARY, COLOR_DISABLED, COLOR_INVERTED, COLOR_LINK, COLOR_NEGATIVE, COLOR_CAUTION, COLOR_POSITIVE];
const _excluded$2 = ["className", "component", "type", "size", "color", "children", "weight"];
const Typography = /*#__PURE__*/function () {
  const Typography = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        className,
        component: Component = 'span',
        type = 'body',
        size = 'm',
        color = 'primary',
        children,
        weight = 'regular'
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2);
    const typographyClassNames = classNames(namespace, className, {
      ["".concat(namespace, "--type-").concat(type)]: type,
      ["".concat(namespace, "--size-").concat(size)]: size,
      ["".concat(namespace, "--color-").concat(color)]: color,
      ["".concat(namespace, "--weight-").concat(weight)]: weight
    });
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: typographyClassNames,
      ref: ref
    }, otherProps), children);
  });
  Typography.displayName = 'Typography';
  return Typography;
}();
var Typography$1 = Typography;
const Text = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Typography$1, _extends({}, props, {
  type: "body",
  ref: ref
})));
Text.displayName = 'Text';
var Text$1 = Text;
const Title = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Typography$1, _extends({}, props, {
  type: "title",
  ref: ref
})));
Title.displayName = 'Title';
var Title$1 = Title;
const _excluded$1 = ["markerColor", "markerType", "children", "className", "color", "srLabel"];
const TextList = /*#__PURE__*/function () {
  const TextList = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        markerColor,
        markerType = 'dot',
        children,
        className,
        color = 'primary',
        srLabel
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);
    const textListClassnames = classNames(textListNamespace, className);
    const component = markerType === 'number' ? 'ol' : 'ul';
    return /*#__PURE__*/React.createElement(Text$1, _extends({}, otherProps, {
      component: component,
      className: textListClassnames,
      "aria-label": srLabel,
      ref: ref
    }), Children.map(children, child => /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({
      markerColor: child.props.markerColor || markerColor || color,
      markerType
    }, otherProps), {}, {
      color: child.props.color || color
    }))));
  });
  TextList.displayName = 'TextList';
  return TextList;
}();
var TextList$1 = TextList;
const _excluded = ["markerColor", "markerType", "className", "children"];
const TextListItem = /*#__PURE__*/function () {
  const TextListItem = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        markerColor,
        markerType = 'dot',
        className,
        children
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    const textListItemClassnames = classNames(textListItemNamespace, className);
    const getCheckIcon = () => {
      const {
        size
      } = otherProps;
      switch (size) {
        case 'xs':
          return FeedbackPositive16;
        case 's':
          return FeedbackPositive18;
        case 'l':
          return FeedbackPositive24;
        case 'm':
        default:
          return FeedbackPositive20;
      }
    };
    const getMarker = () => {
      switch (markerType) {
        case 'number':
          return /*#__PURE__*/_jsx("span", {
            className: "".concat(textListItemNamespace, "-number-marker"),
            "aria-hidden": true
          });
        case 'check':
          {
            const Icon = getCheckIcon();
            const customColor = !includes(AVAILABLE_COLORS, markerColor) ? markerColor : undefined;
            const iconClassNames = classNames("".concat(textListItemNamespace, "-check-marker"), {
              ["".concat(textListItemNamespace, "-check-marker--color-").concat(markerColor)]: includes(AVAILABLE_COLORS, markerColor)
            });
            return /*#__PURE__*/_jsx("span", {
              className: iconClassNames,
              "aria-hidden": true
            }, void 0, /*#__PURE__*/_jsx(Icon, {
              color: customColor
            }));
          }
        case 'dot':
        default:
          return /*#__PURE__*/_jsx("span", {
            className: "".concat(textListItemNamespace, "-dot-marker"),
            "aria-hidden": true
          }, void 0, "\u2022");
      }
    };
    return /*#__PURE__*/React.createElement(Text$1, _extends({}, otherProps, {
      className: textListItemClassnames,
      component: "li",
      ref: ref
    }), getMarker(), children);
  });
  TextListItem.displayName = 'TextListItem';
  return TextListItem;
}();
var TextListItem$1 = TextListItem;
export { Text$1 as Text, TextList$1 as TextList, TextListItem$1 as TextListItem, Title$1 as Title, Typography$1 as Typography, Typography$1 as default };
